import { render, staticRenderFns } from "./EditJobDetails.vue?vue&type=template&id=67c86a2b&scoped=true"
import script from "./EditJobDetails.vue?vue&type=script&lang=ts"
export * from "./EditJobDetails.vue?vue&type=script&lang=ts"
import style0 from "./EditJobDetails.vue?vue&type=style&index=0&id=67c86a2b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c86a2b",
  null
  
)

export default component.exports